import React, { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Page, Button, Input, Tabs } from 'equasion-lib';
import { FiChevronLeft, FiSearch } from 'react-icons/fi';

const TAB_FROM_URL: Record<string, string> = {
  receiving: 'receiving',
  stocking: 'received'
};
const TAB_TO_URL: Record<string, string> = {
  receiving: 'receiving',
  received: 'stocking'
};

const PlaceholderPurchaseOrders = ({ purchaseOrders }) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab');
  const selectedTab = useMemo(() => {
    const mapped = tabFromUrl ? TAB_FROM_URL[tabFromUrl] : undefined;
    return mapped ?? 'receiving';
  }, [tabFromUrl]);

  const [search, setSearch] = useState('');

  const handleTabChange = (value: string) => {
    const urlTab = TAB_TO_URL[value];
    setSearchParams(urlTab ? { tab: urlTab } : {});
  };

  const handleRowClick = (po) => {
    if (po.clientStatus === 'receiving') {
      navigate(`/placeholder-receiving/${po.id}`);
    } else {
      navigate(`/placeholder-stocking/${po.id}`);
    }
  };

  const filtered = (purchaseOrders || [])
    .filter(({ clientStatus }) => clientStatus === selectedTab)
    .filter(({ clientPurchaseOrderNumber, vendor }) => {
      const companyName = vendor?.companyName ?? '';
      const q = search.toLowerCase();
      return (
        (clientPurchaseOrderNumber || '').toLowerCase().includes(q) ||
        companyName.toLowerCase().includes(q)
      );
    });

  return (
    <Page className="otc-purchase-orders action-page">
      <div className="action-top-bar">
        <Button
          type="secondary"
          iconBefore={<FiChevronLeft />}
          onClick={() => navigate('/')}
        >
          Back
        </Button>
        <div className="order-details" style={{ textAlign: 'right' }}>
          <h1>Approved Unserialized</h1>
          <h2>
            {(purchaseOrders || []).length} Order
            {(purchaseOrders || []).length === 1 ? '' : 's'}
          </h2>
        </div>
      </div>
      <div className="action-page-body">
        <div className="top-filters">
          <Tabs
            menuOnly
            selectedKey={selectedTab}
            onTabChange={handleTabChange}
            data={[
              { label: 'Receiving', key: 'receiving' },
              { label: 'Stocking', key: 'received' }
            ]}
          />
          <Input
            form={false}
            label="Search"
            iconAfter={<FiSearch />}
            value={search}
            onChange={({ value }) => setSearch(value)}
          />
        </div>
        <div className="purchase-order-list">
          {filtered.length === 0 && (
            <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--n100)' }}>
              No orders to {selectedTab === 'receiving' ? 'receive' : 'stock'}.
            </div>
          )}
          {filtered.map((po) => (
            <div
              key={po.id}
              className="purchase-order-row"
              onClick={() => handleRowClick(po)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleRowClick(po);
                }
              }}
              style={{
                padding: '1.6rem',
                borderBottom: '1px solid var(--n600)',
                cursor: 'pointer',
                backgroundColor: 'var(--n800)'
              }}
            >
              <div style={{ fontWeight: 600, color: 'var(--n0)' }}>
                PO #{po.clientPurchaseOrderNumber}
              </div>
              <div style={{ color: 'var(--n100)', fontSize: '1.3rem' }}>
                {po.vendor?.companyName}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Page>
  );
};

export default PlaceholderPurchaseOrders;
